/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Basic_Keyword_GroupInputs */



/**
* | output |
* | --- |
* | "Basic Keyword Group" |
*
* @param {Subtitle_Export_Basic_Keyword_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_basic_keyword_group = /** @type {((inputs?: Subtitle_Export_Basic_Keyword_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Basic_Keyword_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe de mots clés de base")
	if (locale === "de") return /** @type {LocalizedString} */ ("Grundlegende Schlüsselwortgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di parole chiave di base")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Базовая группа ключевых слов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo básico de palabras clave")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("基本关键词组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("基本キーワードグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बुनियादी कीवर्ड समूह")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de palavras-chave básicas")
	return /** @type {LocalizedString} */ ("Basic Keyword Group")
});